import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { useTranslation } from 'react-i18next';
import { iProspectFile, eCrmProspectStatus } from 'services/Crm/Crm.type';
import KanbanCard from './KanbanCard';
import s from '../CrmPipeline.module.scss';

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  new: { bg: '#dbeafe', text: '#1e40af' },
  contacted: { bg: '#fef3c7', text: '#92400e' },
  qualified: { bg: '#ede9fe', text: '#5b21b6' },
  proposal: { bg: '#e0e7ff', text: '#3730a3' },
  negotiation: { bg: '#ffedd5', text: '#9a3412' },
  won: { bg: '#dcfce7', text: '#166534' },
};

interface KanbanColumnProps {
  status: eCrmProspectStatus;
  prospects: iProspectFile[];
}

function KanbanColumn({ status, prospects }: KanbanColumnProps): JSX.Element {
  const { t } = useTranslation();
  const { setNodeRef, isOver } = useDroppable({ id: status });

  const colors = STATUS_COLORS[status] ?? { bg: '#f1f5f9', text: '#475569' };

  return (
    <div
      ref={setNodeRef}
      className={`${s.column} ${isOver ? s.columnOver : ''}`}
    >
      <div
        className={s.columnHeader}
        style={{ backgroundColor: colors.bg, color: colors.text }}
      >
        <span>{t(`crm:status_${status}`)}</span>
        <span className={s.columnCount}>{prospects.length}</span>
      </div>
      <div className={s.columnCards}>
        {prospects.map((prospect) => (
          <KanbanCard key={prospect.id} prospect={prospect} />
        ))}
        {prospects.length === 0 && (
          <div className={s.emptyColumn}>{t('crm:no_prospects_in_column')}</div>
        )}
      </div>
    </div>
  );
}

export default KanbanColumn;
